function C(i, p) {
  typeof i == "string" && (i = i.replace(".", ""));
  let d = "";
  const n = /\{\{\s*(\w+)\s*\}\}/,
    a = p || "${{amount}}";
  function t(c, s) {
    return typeof c > "u" ? s : c;
  }
  function r(c, s, e, m) {
    if (
      ((s = t(s, 2)), (e = t(e, ",")), (m = t(m, ".")), isNaN(c) || c == null)
    )
      return 0;
    c = (c / 100).toFixed(s);
    const h = c.split("."),
      g = h[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + e),
      u = h[1] ? m + h[1] : "";
    return g + u;
  }
  switch (a.match(n)[1]) {
    case "amount":
      d = r(i, 2);
      break;
    case "amount_no_decimals":
      d = r(i, 0);
      break;
    case "amount_with_comma_separator":
      d = r(i, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      d = r(i, 0, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      d = r(i, 2, "'", ".");
      break;
  }
  return a.replace(n, d);
}
function j() {
  function i(a, t, r) {
    if (a) {
      return (a.innerHTML = '<span class="money">' + C(t, r) + "</span>");  
    }
  }
  function p(a, t) {
    return a.sellingPlans.find((r) => r.id === Number(t));
  }
  function d(a) {
    let t = a.querySelector('input[name="selling_plan"]');
    return (
      t ||
        ((t = document.createElement("input")),
        (t.type = "hidden"),
        (t.name = "selling_plan"),
        a.append(t)),
      t
    );
  }
  function n(a, t, r) {
    const s = Array.from(
        document.querySelectorAll('form[action$="/cart/add"]')
      ).map(d),
      e = document.querySelector("#juo-subscription-widget"),
      m = e.querySelector('[part="subscription-price"]'),
      h = e.querySelector('[part="price price--base"]'),
      g = e.querySelector('[part="compare-price"]'),
      u = e.querySelector('[part="select"]');
    function L() {
      return e.querySelector('input[name="mode"]:checked').value;
    }
    function w() {
      return L() === "otp" ? "" : e.querySelector("select").value;
    }
    function S() {
      const l = w();
      s.forEach((o) => {
        o.value = l;
      });
    }
    function b() {
      const o = new URL(window.location.href).searchParams.get("variant") || t;
      return a.find(({ id: f }) => f == o) || a.find(Boolean);
    }
    function _(l, o) {
      const f = e.querySelector('[data-ref="save"]');
      if ((e.querySelector(".j-save"), f)) {
        const y = (o / l) * 100;
        f.innerHTML = 100 - Math.round(y);
      }
    }
    function E(l = [], o) {
      if (u.dataset.activeVariant === String(o)) return;
      let f = "";
      if (
        (l.forEach((y) => {
          f += `<option value="${y.id}">${y.name}</option>`;
        }),
        (u.innerHTML = f),
        l.length === 0)
      ) {
        u.value = "";
        return;
      }
      (u.dataset.activeVariant = o),
        (u.value = u == null ? void 0 : u.children[0].value),
        S();
    }
    function P() {
      const l = b(),
        o = p(l, u.value);
      if ((E(l.sellingPlans, l.id), o == null)) {
        e == null || e.classList.add("juo-hidden");
        return;
      } else e == null || e.classList.remove("juo-hidden");
      o.comparePrice > o.price && _(o.comparePrice, o.price),
        i(h, l.price, r),
        i(m, o.price, r),
        o.price < o.comparePrice && l.price !== o.price
          ? i(g, o.comparePrice, r)
          : (g.innerHTML = "");
    }
    function v() {
      S(), P();
    }
    v(),
      document.addEventListener("change", v),
      u.addEventListener("change", () => {
        e.querySelector('input[name="mode"][value="subscription"]').click();
      });
  }
  if (window.Shopify != null) {
    let a = function () {
      var e;
      const [t, r, c, s] = JSON.parse(
        ((e = document.getElementById("juo-subscription-widget-data")) == null
          ? void 0
          : e.innerText) ?? "[]"
      );
      n(t, r, c);
    };
    document.readyState === "complete" ||
    document.readyState === "loaded" ||
    document.readyState === "interactive"
      ? a()
      : document.addEventListener("DOMContentLoaded", a);
  }
}
function M() {
  const i = document.querySelector("#juo-subscription-widget"),
    p = document.querySelector(".j-subscription"),
    d = document.querySelector(".j-otp"),
    n = i.querySelector(".j-subscription-details");
  function a() {
    return (
      i.querySelector('input[name="mode"]:checked').value === "subscription"
    );
  }
  let t = a();
  (n.style.height = t ? "auto" : "0"), (n.style.overflow = "hidden");
  function r() {
    const e = getComputedStyle(n).height;
    n.style.height = "auto";
    const m = getComputedStyle(n).height;
    (n.style.height = e),
      getComputedStyle(n).height,
      requestAnimationFrame(function () {
        n.style.height = m;
      });
  }
  function c() {
    const e = getComputedStyle(n).height;
    (n.style.height = e),
      getComputedStyle(n).height,
      requestAnimationFrame(function () {
        n.style.height = "0";
      });
  }
  function s() {
    const e = a();
    p.classList[e ? "add" : "remove"]("active"),
      d.classList[e ? "remove" : "add"]("active"),
      e !== t && ((t = e), e ? r() : c());
  }
  (n.style.transition = "height 300ms ease-in-out"),
    s(),
    i.addEventListener("change", s),
    n.addEventListener("transitionend", function () {
      Number.parseFloat(n.style.height) > 0.1 && (n.style.height = "auto");
    });
}
function q() {
  if (window.Shopify != null) {
    let i = function () {
      var p;
      JSON.parse(
        ((p = document.getElementById("juo-subscription-widget-data")) == null
          ? void 0
          : p.innerText) ?? "[]"
      ),
        j(),
        M();
    };
    document.readyState === "complete" ||
    document.readyState === "loaded" ||
    document.readyState === "interactive"
      ? i()
      : document.addEventListener("DOMContentLoaded", i);
  }
}
document.readyState === "loading"
  ? document.addEventListener("DOMContentLoaded", q)
  : q();
